import { render } from "./index.vue?vue&type=template&id=087bfa01"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xiaobiaoza/Desktop/workspace/GIM/WPP/wpp-aigc-aigc-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/basic-layout/menu-side/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "087bfa01"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('087bfa01', __exports__)) {
    console.log('reload')
    api.reload('087bfa01', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=087bfa01", () => {
    console.log('re-render')
    api.rerender('087bfa01', render)
  })

}


export default __exports__